import { useQuery } from '@tanstack/react-query'

import { useAppSelector } from 'common/hooks/redux'

import { fetchVariants } from '../api'
import { personalizationKeys } from '../queryKeys'

export type Variant = {
  channelType: string
  clicks: number
  opens: number
  name: string
  sends: number
}

export type VariantsData = {
  count: number
  variants: Variant[]
}

const useGetVariantsQuery = (personalizationId: string) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const query = useQuery(
    personalizationKeys.variants(accountId),
    () => fetchVariants({ accountId, personalizationId }),
    {
      select: (data): VariantsData => ({
        count: data.filteredCount,
        variants: data.items.map((variant) => ({
          channelType: variant.channel,
          clicks: variant.clicks,
          opens: variant.opens,
          name: variant.variantText,
          sends: variant.sends,
        })),
      }),
    }
  )

  return query
}

export default useGetVariantsQuery
